package com.schoolconnect.app.datasource.network.request

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class SchoolCreateRequest(
    @SerialName("id")
    val id: String? = null,
    @SerialName("name")
    val name: String,
    @SerialName("board")
    val board: String,
    @SerialName("school_type")
    val schoolType: String,
    @SerialName("medium")
    val medium: String,
    @SerialName("address_line1")
    val addressLine1: String,
    @SerialName("address_line2")
    val addressLine2: String? = null,
    @SerialName("city")
    val city: String,
    @SerialName("district")
    val district: String,
    @SerialName("state")
    val state: String,
    @SerialName("country")
    val country: String,
    @SerialName("pin_code")
    val pinCode: String,
    @SerialName("school_phone")
    val schoolPhone: String,
    @SerialName("school_email")
    val schoolEmail: String,
    @SerialName("primary_contact_name")
    val primaryContactName: String,
    @SerialName("primary_contact_phone")
    val primaryContactPhone: String,
    @SerialName("primary_contact_email")
    val primaryContactEmail: String,
    @SerialName("secondary_contact_name")
    val secondaryContactName: String? = null,
    @SerialName("secondary_contact_phone")
    val secondaryContactPhone: String? = null,
    @SerialName("secondary_contact_email")
    val secondaryContactEmail: String? = null,
    @SerialName("school_description")
    val schoolDescription: String? = null,
)
